import { BROADCAST_MUTE_AUDIO, BROADCAST_UNMUTE_AUDIO } from 'actions/Types';
import { BROADCAST_SET_ATTENDEE_MUTE_STATUS } from '@shoflo/studio-redux/actions/types';

function isAudioMuted(state = true, action) {
  if (action.type === BROADCAST_MUTE_AUDIO) {
    return action.payload;
  }

  if (action.type === BROADCAST_UNMUTE_AUDIO) {
    return action.payload;
  }

  if (action.type === BROADCAST_SET_ATTENDEE_MUTE_STATUS) {
    return action.payload.isMuted;
  }

  return state;
}

export default isAudioMuted;
